import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Form, Button, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as action from '../../../actions/videos/trainingVideos';
import {
  DEFAULT_TYPE_OF_VIDEOS_KEYS,
  MAIN_VIDEO_TYPE_ID,
  LIMBERING_UP_VIDEO_TYPE_ID,
  INTERRUPTION_VIDEO_TYPE_ID,
} from '../../../constants/appConstants';
import debounce from '../../../utils/debounce';

const DEFAULT_TYPE_OF_TRAINING_VIDEOS = [
  { text: 'Разминка', value: 'limbering_up' },
  { text: 'Основное видео', value: 'main_video' },
  { text: 'Заминка', value: 'interruption' },
  { text: 'Саморазвитие', value: 'self_development' },
  { text: 'Мотивация', value: 'motivation' },
  { text: 'Приветствие', value: 'welcome' },
  { text: 'FAQ', value: 'faq' },
];

const ChangeSubTemplateVideos = ({
  subtemplateVideo,
  setSubtemplateVideo,
  trainingVideosList,
  createSubtemplateVideo,
  changeSubtemplateVideo,
  limberingUpVideosList,
  interruptionVideosList,
  selfDevelopmentVideosList,
  motivationVideosList,
  welcomeVideosList,
  faqVideosList,
  searchVideos,
}) => {
  const [templateName, setTemplateName] = useState(
    (!!subtemplateVideo && subtemplateVideo.name) || '',
  );
  const [isNameNotFilled, setIsNameNotFilled] = useState(false);
  const [isSelectNotFilled, setIsSelectNotFilled] = useState(false);
  const [selectedTrainingsSubpatternsList, setSelectedTrainingsSubpatternsList] = useState(
    (!!subtemplateVideo && subtemplateVideo.videos) || {
      main_video: null,
      limbering_up: null,
      interruption: null,
      self_development: null,
      motivation: null,
      welcome: null,
      faq: null,
    },
  );
  const [uniqueTags, setUniqueTags] = useState([]);
  const [disabledField, setDisabledField] = useState(false);
  const [videosOptions, setVideosOptions] = useState({
    main_video: [],
    limbering_up: [],
    interruption: [],
    self_development: [],
    motivation: [],
    welcome: [],
    faq: [],
  });

  const handleTemplateName = React.useCallback(
    (e) => {
      setTemplateName(e.target.value);
      setIsNameNotFilled(false);
    },
    [setTemplateName, setIsNameNotFilled],
  );

  const handleSelectedDay = React.useCallback(
    (event, data, index, videosList) => {
      setIsSelectNotFilled(false);
      let newSelectedDaysVideos = videosList.find((videos) => {
        if (videos.name === data.value) {
          return videos;
        }
      });

      if (!newSelectedDaysVideos) {
        newSelectedDaysVideos = null;
      }

      const newSelecteVideos = DEFAULT_TYPE_OF_VIDEOS_KEYS.map((videoType, subTemplateIndex) => {
        const subTemplate = selectedTrainingsSubpatternsList[videoType];
        let newSubTemplate = subTemplate;
        if (newSelectedDaysVideos == null) return newSelectedDaysVideos;
        if (subTemplateIndex === index) {
          newSubTemplate = {
            url: newSelectedDaysVideos.url,
            name: newSelectedDaysVideos.name,
            tags: newSelectedDaysVideos.tags,
            video_type:
              newSelectedDaysVideos.video_type === undefined
                ? subTemplate.video_type
                : newSelectedDaysVideos.video_type,
            id: newSelectedDaysVideos.id,
          };
        }
        return newSubTemplate;
      });
      const newSelectedTrainingsSubpatternsList = {};
      DEFAULT_TYPE_OF_VIDEOS_KEYS.forEach((newSubTemplate, i) => {
        newSelectedTrainingsSubpatternsList[newSubTemplate] =
          newSelecteVideos[i] === null
            ? null
            : {
                ...newSelecteVideos[i],
              };
      });
      setSelectedTrainingsSubpatternsList(newSelectedTrainingsSubpatternsList);
    },
    [setIsSelectNotFilled, setSelectedTrainingsSubpatternsList, selectedTrainingsSubpatternsList],
  );

  const onSaveTemplateVideo = React.useCallback(
    (e) => {
      if (templateName === '') {
        setIsNameNotFilled(true);
        return;
      }
      let isSubTemplateValueFilled = false;
      const videosId = {};
      DEFAULT_TYPE_OF_VIDEOS_KEYS.map((videoType) => {
        const subTemplate = selectedTrainingsSubpatternsList[videoType];
        if (videoType === 'main_video' || videoType === 'self_development') {
          if (subTemplate === null || !subTemplate.url) {
            setIsSelectNotFilled(true);
          } else isSubTemplateValueFilled = true;
        }
        if (subTemplate !== null) {
          videosId[videoType] = subTemplate.id;
        } else videosId[videoType] = null;
        return null;
      });
      if (isSubTemplateValueFilled) {
        setIsSelectNotFilled(false);
      } else return;
      setSubtemplateVideo({
        name: templateName,
        videos: selectedTrainingsSubpatternsList,
      });
      if (subtemplateVideo && subtemplateVideo.id) {
        changeSubtemplateVideo({
          name: templateName,
          videos: videosId,
          id: subtemplateVideo.id,
        });
      } else {
        createSubtemplateVideo({
          name: templateName,
          videos: videosId,
        });
      }
    },
    [setSubtemplateVideo, templateName, selectedTrainingsSubpatternsList, setIsSelectNotFilled],
  );

  const searchUniqueTags = React.useCallback(() => {
    // add in all videos pages
    const subTemplateTagsIds = [];
    const subTemplateTags = [];
    selectedTrainingsSubpatternsList &&
      DEFAULT_TYPE_OF_VIDEOS_KEYS.forEach((videoType) => {
        const subTemplate = selectedTrainingsSubpatternsList[videoType];
        if (!subTemplate) return;
        !!subTemplate.tags &&
          subTemplate.tags.forEach((tag) => {
            if (!subTemplateTagsIds.includes(tag.tag_id)) {
              subTemplateTagsIds.push(tag.tag_id);
              subTemplateTags.push(tag);
            }
          });
      });
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!subTemplateTags.length) {
      setUniqueTags(subTemplateTags);
    }
  }, [selectedTrainingsSubpatternsList, setUniqueTags]);

  const cleanDisabledFields = React.useCallback(() => {
    const cleanField = {
      id: null,
      url: null,
      name: null,
      tags: [],
    };

    const cleanedSubpatternsList = DEFAULT_TYPE_OF_VIDEOS_KEYS.map((videoType) => {
      const subTemplate = selectedTrainingsSubpatternsList[videoType];
      if (subTemplate === null) return;
      if (
        subTemplate.video_type === LIMBERING_UP_VIDEO_TYPE_ID ||
        subTemplate.video_type === INTERRUPTION_VIDEO_TYPE_ID
      ) {
        subTemplate.url = cleanField.url;
        subTemplate.name = cleanField.name;
        subTemplate.tags = cleanField.tags;
      }
      return subTemplate;
    });
    setSelectedTrainingsSubpatternsList(cleanedSubpatternsList);
  }, [selectedTrainingsSubpatternsList, setSelectedTrainingsSubpatternsList]);

  const disabledFields = React.useCallback(() => {
    selectedTrainingsSubpatternsList &&
      DEFAULT_TYPE_OF_VIDEOS_KEYS.forEach((videoType) => {
        const subTemplate = selectedTrainingsSubpatternsList[videoType];
        if (subTemplate === null) return;
        if (subTemplate.video_type === MAIN_VIDEO_TYPE_ID) {
          if (!subTemplate.url) {
            setDisabledField(true);
            cleanDisabledFields();
          } else setDisabledField(false);
        }
      });
  }, [selectedTrainingsSubpatternsList, setDisabledField, cleanDisabledFields]);

  useEffect(() => {
    searchUniqueTags();
    disabledFields();
    DEFAULT_TYPE_OF_VIDEOS_KEYS.forEach((type) => searchVideos(type));
  }, []);

  useEffect(() => {
    const newVideosOptions = {};
    newVideosOptions.main_video = trainingVideosList;
    newVideosOptions.limbering_up = limberingUpVideosList;
    newVideosOptions.interruption = interruptionVideosList;
    newVideosOptions.self_development = selfDevelopmentVideosList;
    newVideosOptions.motivation = motivationVideosList;
    newVideosOptions.welcome = welcomeVideosList;
    newVideosOptions.faq = faqVideosList;
    if (!subtemplateVideo) {
      DEFAULT_TYPE_OF_VIDEOS_KEYS.forEach((type, i) => {
        if (subtemplateVideo.videos[type]) {
          let isVideoAlreadyOnList = false;
          newVideosOptions[DEFAULT_TYPE_OF_VIDEOS_KEYS[i]].forEach((video) => {
            if (video === subtemplateVideo.videos[type]) isVideoAlreadyOnList = true;
          });
          if (!isVideoAlreadyOnList)
            newVideosOptions[DEFAULT_TYPE_OF_VIDEOS_KEYS[i]].push(subtemplateVideo.videos[type]);
        }
      });
    }
    setVideosOptions(newVideosOptions);
  }, [
    trainingVideosList,
    limberingUpVideosList,
    interruptionVideosList,
    selfDevelopmentVideosList,
    motivationVideosList,
    welcomeVideosList,
    faqVideosList,
  ]);

  useEffect(() => {
    searchUniqueTags();
    disabledFields();
  }, [selectedTrainingsSubpatternsList]);

  const handleSearchVideos = React.useCallback(
    (event, data, type) => {
      searchVideos(type, data.searchQuery);
    },
    [searchVideos],
  );

  return (
    <ChangeSubTemplateVideoBlock>
      <MainTitle>Управление подшаблонами видео тренировок</MainTitle>
      <Form onSubmit={(e) => onSaveTemplateVideo(e)}>
        <Form.Field error={isNameNotFilled}>
          <SelectVideosBlockName>
            <TitleOfFormField required>Имя подшаблона</TitleOfFormField>
            <input
              onChange={(e) => handleTemplateName(e)}
              value={templateName}
              placeholder="Введите имя подшаблона"
            />
          </SelectVideosBlockName>
        </Form.Field>
        {DEFAULT_TYPE_OF_TRAINING_VIDEOS.map((videoType, i) => {
          return (
            <Form.Field
              key={videoType.value}
              error={
                videoType.value === 'main_video' || videoType.value === 'self_development'
                  ? isSelectNotFilled
                  : false
              }
            >
              <SelectVideosBlock>
                <TitleOfFormField>{videoType.text}</TitleOfFormField>
                <Dropdown
                  placeholder="Выберите видео"
                  clearable
                  fluid
                  search
                  selection
                  error={videoType.value === 'main_video' && isSelectNotFilled}
                  disabled={
                    videoType.value === 'limbering_up' || videoType.value === 'interruption'
                      ? disabledField
                      : false
                  }
                  value={
                    selectedTrainingsSubpatternsList[videoType.value] !== null
                      ? selectedTrainingsSubpatternsList[videoType.value].name
                      : ''
                  }
                  options={videosOptions[videoType.value].map((video) => {
                    return { key: video.id, text: video.name, value: video.name };
                  })}
                  onChange={(e, data) =>
                    handleSelectedDay(e, data, i, videosOptions[videoType.value])
                  }
                  onSearchChange={debounce(
                    (e, data) => handleSearchVideos(e, data, videoType.value),
                    1000,
                  )}
                />
              </SelectVideosBlock>
            </Form.Field>
          );
        })}
        <Form.Field>
          <TagsContentBlock>
            <TitleOfFormField>Используемые теги</TitleOfFormField>
            <VideoTagsBlock>
              {!!uniqueTags &&
                uniqueTags.map((tag) => {
                  return <TagsTitle key={tag.tag_id}>{tag.name}</TagsTitle>;
                })}
            </VideoTagsBlock>
          </TagsContentBlock>
        </Form.Field>
        <SubmitButton>
          <Button positive type="submit">
            Сохранить
          </Button>
        </SubmitButton>
      </Form>
    </ChangeSubTemplateVideoBlock>
  );
};

const mapStateToProps = (state) => {
  const {
    subtemplateVideo,
    trainingVideosList,
    limberingUpVideosList,
    interruptionVideosList,
    selfDevelopmentVideosList,
    motivationVideosList,
    welcomeVideosList,
    faqVideosList,
  } = state.trainingVideos;

  return {
    subtemplateVideo,
    trainingVideosList,
    limberingUpVideosList,
    interruptionVideosList,
    selfDevelopmentVideosList,
    motivationVideosList,
    welcomeVideosList,
    faqVideosList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSubtemplateVideo: (subtemplateVideo) => {
      dispatch(action.setSubtemplateVideo(subtemplateVideo));
    },
    createSubtemplateVideo: (subtemplateVideo) => {
      dispatch(action.createSubtemplateVideo(subtemplateVideo));
    },
    changeSubtemplateVideo: (subtemplateVideo) => {
      dispatch(action.changeSubtemplateVideo(subtemplateVideo));
    },
    searchVideos: (type, name) => {
      dispatch(action.searchVideos(type, name));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeSubTemplateVideos);

const MainTitle = styled.h1`
  font-size: 24px;
  text-align: center;
  padding-top: 10px;
`;

const ChangeSubTemplateVideoBlock = styled.div`
  width: 50%;
  margin: 0 auto;
`;

const SelectVideosBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

const SelectVideosBlockName = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
`;

const TagsContentBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

const TitleOfFormField = styled.p`
  font-size: 14px;
  text-align: flex-start;
  margin-top: 10px;
  margin-bottom: 0;
  width: 140px;
`;

const TagsTitle = styled.p`
  font-size: 14px;
  margin-right: 10px;
`;

const VideoTagsBlock = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
`;

const SubmitButton = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/Components/Videos/ChangeVideosList/ChangeSubTemplateVideos.jsx